const moduleKey = 'BANK';

export const bankTypes = {
  LOAD_REQUESTED: moduleKey + "_LOAD_REQUESTED",
  LOADED: moduleKey + "_LOADED",
  SET_TABLE_CONFIG: moduleKey + "_SET_TABLE_CONFIG",
  SET_TABLE_CONFIG_FILTER: moduleKey + "_SET_TABLE_CONFIG_FILTER",
  CHANGE_TAB: moduleKey + '_CHANGE_TAB',
  CLOSE_TAB: moduleKey + '_CLOSE_TAB',
  CREATE_TAB: moduleKey + '_CREATE_TAB',
  GET_DETAIL_REQUESTED: moduleKey + '_GET_DETAIL_REQUESTED',
  GET_DETAIL_LOADED: moduleKey + '_GET_DETAIL_LOADED',
  UPDATE_SUCCESS: moduleKey + '_UPDATE_SUCCESS'
};

export const bankActions = {
  loadRequested: (tableConfig) => ({ type: bankTypes.LOAD_REQUESTED, tableConfig }),
  loaded: (data) => ({ type: bankTypes.LOADED, payload: { data } }),
  setTableConfig: (key, value) => ({ type: bankTypes.SET_TABLE_CONFIG, key, value }),
  setTableConfigFilter: (key, value) => ({ type: bankTypes.SET_TABLE_CONFIG_FILTER, key, value }),
  changeTab: (key) => ({ type: bankTypes.CHANGE_TAB, key }),
  closeTab: (key) => ({ type: bankTypes.CLOSE_TAB, key }),
  createTab: (key, title) => ({ type: bankTypes.CREATE_TAB, key, title }),
  getDetail: (id, index) => ({ type: bankTypes.GET_DETAIL_REQUESTED, id, index }),
  getDetailLoaded: (data, index) => ({ type: bankTypes.GET_DETAIL_LOADED, payload: { data }, index }),
  updateSuccess: (index) => ({ type: bankTypes.UPDATE_SUCCESS, index })
};
